export default __webpack_public_path__ + "9e6f657b9a41fd3d48be8fc547bcf19f.ttf";